import * as React from 'react'

const NegligiblePlan = () => (
  <svg width="8" height="8" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="3" fill="#DAE7F7" />
  </svg>
)

export default NegligiblePlan
